import React from 'react';

const RouteErrorFallback = ({ error, onRetry }) => (
  <div className="container-fluid py-5" role="alert">
    <div className="row justify-content-center">
      <div className="col-md-8 col-lg-6 text-center">
        <div className="card border-0 shadow-sm">
          <div className="card-body p-4 p-md-5">
            <div className="mb-3 text-danger" aria-hidden="true" style={{ fontSize: 36, lineHeight: 1 }}>
              !
            </div>
            <h4 className="mb-2">Terjadi kesalahan pada halaman ini.</h4>
            <p className="text-muted mb-4">
              Halaman gagal ditampilkan. Anda bisa mencoba memuat ulang halaman ini tanpa keluar dari aplikasi.
            </p>
            {process.env.NODE_ENV !== 'production' && error && (
              <pre className="text-left bg-light p-3 mb-4" style={{ maxHeight: 180, overflow: 'auto', fontSize: 12 }}>
                {error.stack || error.message || String(error)}
              </pre>
            )}
            <button type="button" className="btn btn-primary" onClick={onRetry}>
              Coba lagi
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default RouteErrorFallback;